import type React from 'react';
import classes from './shift-header.module.scss';
import { NavLink } from 'react-router-dom';
import { useShiftHeaderController } from './useShiftHeaderController';
import { ShiftPwaControls } from '../ShiftPwaControls';
import { Burger, Menu } from '@mantine/core';

export const ShiftHeader: React.FC = () => {
  const { user, navigate, location, openMenu, setOpenMenu, menuWrapRef, onLogout,
    openNavigationMenu, onNavigationMenuChange, onToggleUserMenu } =
    useShiftHeaderController();

  return (
    <header className={classes.shiftHeader} dir="rtl">
      <div className={classes.brandTitle}>Comm.it SHIFT</div>

      <nav className={classes.headerNav} dir="rtl">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            `${classes.headerNavLink}${isActive || location.pathname === '/' ? ' active' : ''}`
          }
        >
          דף הבית
        </NavLink>
        <NavLink
          to="/employees"
          className={({ isActive }) => `${classes.headerNavLink}${isActive ? ' active' : ''}`}
        >
          עובדים
        </NavLink>
        <NavLink
          to="/availability"
          className={({ isActive }) => `${classes.headerNavLink}${isActive ? ' active' : ''}`}
        >
          זמינות
        </NavLink>
        <NavLink
          to="/schedule"
          className={({ isActive }) => `${classes.headerNavLink}${isActive ? ' active' : ''}`}
        >
          סידור עבודה
        </NavLink>
        <NavLink
          to="/reports"
          className={({ isActive }) => `${classes.headerNavLink}${isActive ? ' active' : ''}`}
        >
          דוחות
        </NavLink>
        <Menu opened={openNavigationMenu} onChange={onNavigationMenuChange} position="bottom-end" withinPortal>
          <Menu.Target>
            <Burger opened={openNavigationMenu} size="sm" color="white" className={classes.navigationMenuButton}
              aria-label="תפריט נוסף" title="תפריט נוסף" />
          </Menu.Target>
          <Menu.Dropdown dir="rtl" className={classes.navigationDropdown}>
            <Menu.Item component={NavLink} to="/vacations" data-active={location.pathname==='/vacations' || undefined}>חופשים</Menu.Item>
            <Menu.Item component={NavLink} to="/attendance" data-active={location.pathname==='/attendance' || undefined}>נוכחות</Menu.Item>
            <Menu.Item component={NavLink} to="/notifications" data-active={location.pathname==='/notifications' || undefined}>התראות</Menu.Item>
            {user?.role==='manager' && <>
              <Menu.Divider />
              <Menu.Label>הגדרות</Menu.Label>
              <Menu.Item component={NavLink} to="/staffing-demand" data-active={location.pathname==='/staffing-demand' || undefined}>מכסות כוח אדם</Menu.Item>
              <Menu.Item component={NavLink} to="/employee-scheduling" data-active={location.pathname==='/employee-scheduling' || undefined}>כללי שיבוץ</Menu.Item>
              <Menu.Item component={NavLink} to="/costs" data-active={location.pathname==='/costs' || undefined}>עלויות</Menu.Item>
            </>}
          </Menu.Dropdown>
        </Menu>
      </nav>
      <div className={classes.menuWrap} ref={menuWrapRef}>
        <button
          className={classes.userMenuButton}
          type="button"
          aria-label={user?.username}
          aria-expanded={openMenu}
          title={user?.username}
          onClick={onToggleUserMenu}
        >
          <span aria-hidden="true">{Array.from(user?.username.trim() || '?')[0].toLocaleUpperCase()}</span>
        </button>
        {openMenu && (
          <div className={classes.dropdown}>
            <ShiftPwaControls onInstallAction={() => setOpenMenu(false)} />
            <button
              type="button"
              onClick={() => {
                setOpenMenu(false);
                navigate('/profile');
              }}
            >
              פרופיל
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenMenu(false);
                navigate('/change-password');
              }}
            >
              שינוי סיסמה
            </button>
            <button type="button" onClick={onLogout}>
              התנתקות
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
